import axios from '@lib/axios';
import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

interface Request {
	includesNewsletterLists: boolean;
}

interface Props {
  contentId?: string;
	onSuccess?: (res: AxiosResponse) => void;
  onError?: (res: AxiosError) => void;
}

export const useSendContent = ({
  contentId,
	onSuccess,
  onError
}: Props) => {
	const {
		mutate: onSendContent,
		...rest
	} = useMutation({
		mutationFn: async ({ includesNewsletterLists }: Request) => await axios.post(`/contents/${contentId}/send-content`, { includesNewsletterLists }),
		onSuccess,
    onError
	});

	return { onSendContent, ...rest };
};